// extracted by mini-css-extract-plugin
export default {"root":"_3TelIj6I","heading":"_3Fqe4F5A","icon":"UUiP9AfC"};